import { ability as backend } from '@/api'

export default {

  namespaced: true,

  state: {
    abilities: []
  },

  mutations: {
    setAbilities: (state, abilities) => state.abilities = abilities
  },

  actions: {
    loadAbilities: ({commit}) => new Promise((resolve, reject) => {
      backend.loadAbilities(({data}) => {
        commit('setAbilities', data)
        resolve()
      }, reject)
    }),
    allowAbility: ({}, payload) => new Promise((resolve, reject) => {
      backend.allowAbility(payload, ({data}) => {
        resolve()
      }, reject)
    }),
    removeAbility: ({}, payload) => new Promise((resolve, reject) => {
      backend.removeAbility(payload, ({data}) => {
        resolve()
      }, reject)
    }),
    allowAllAbilities: ({}, payload) => new Promise((resolve, reject) => {
      const userId = typeof payload === 'object' ? payload.userId : payload
      const abilityIds = typeof payload === 'object' ? payload.abilityIds : undefined
      backend.allowAllAbilities(userId, ({data}) => { resolve() }, reject, abilityIds)
    }),
    removeAllAbilities: ({}, payload) => new Promise((resolve, reject) => {
      const userId = typeof payload === 'object' ? payload.userId : payload
      const abilityIds = typeof payload === 'object' ? payload.abilityIds : undefined
      backend.removeAllAbilities(userId, ({data}) => { resolve() }, reject, abilityIds)
    })
  },

  getters: {
    abilities: state => state.abilities
  }

}
